import dayjs from "dayjs";

export const formatToLongDate = (dateString) => {
  return dayjs(dateString).format("MMMM D, YYYY");
};

export const handleDownload = async (url, fileName, mimeType) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();

    const extension = mimeType?.split("/")?.[1]?.split(";")?.[0] || "file";
    const finalFileName = fileName.includes(".")
      ? fileName
      : `${fileName}.${extension}`;

    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = finalFileName;
    a.style.display = "none";

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("File download failed:", error);
  }
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};
